<template>

    <v-flex xs12 mt-4>
        <v-sheet v-if="currentUser" color="transparent" class="pa-1 comment-input-container">
            <div class="comment-input-wrapper align-center">
                <v-form v-model="validComment" @submit.prevent ref="form">
                    <v-flex xs12>
                        <v-text-field
                                v-model="comment"
                                clearable
                                :error-messages="commentErrors"
                                :loading="loading"
                                :readonly="loading"
                                @keyup.enter="sendComment"
                                label="Comentar"
                                placeholder="Escribe algo..."
                                outlined
                                append-icon="mdi-send"
                                @click:append="sendComment"
                                :rules="commentRules"
                        >
                            <template v-slot:prepend>
                                <v-avatar :size="35">
                                    <img :src="avatar">
                                </v-avatar>
                            </template>

                        </v-text-field>
                    </v-flex>

                </v-form>
            </div>
        </v-sheet>
    </v-flex>

</template>
<script>

    import {mapMutations, mapState} from 'vuex'
    import {getFakeAvatar} from '@/utils/Common'

    import {ApiUtils} from '@/utils/ApiUtils'

    export default{
        props: ['ratingId'],
        data(){
            return {
                validComment: false,
                commentRules: [
                    v => v.length >= 2 || 'El comentario debe contener al menos 2 caracteres'
                ],
                loading: false,
                comment: '',
                commentErrors: [],
                deleteConfirmDialog: false
            }
        },
        computed: {
            ...mapState(['currentUser']),
            avatar(){

                var vm = this
                if (!vm.currentUser) return null
                return vm.currentUser.avatar || getFakeAvatar(vm.currentUser.gender)

            },
            title(){
                var vm = this
                if (!vm.currentUser) return ''
                var name = (vm.currentUser.user_name || `${vm.currentUser.first_name} ${vm.currentUser.last_names[0]}.`)

                return `${name}`

            }
        },
        methods: {
            ...mapMutations(['showSnackBar']),
            confirmDelete(){

            },
            async sendComment(evt){

                var vm = this

                if (vm.loading) return

                if (!vm.validComment) {
                    vm.showSnackBar('El comentario debe tener al menos 2 caracteres')
                    return
                }

                if (!vm.ratingId) {
                    throw new Error('rating id is not set')
                }

                vm.loading = true
                const response = await ApiUtils.makePost(`providers/rating/${vm.ratingId}/reply`, {
                    comment: vm.comment
                })
                vm.loading = false

                if (!response.ok) {
                    const json = await response.json()
                    vm.showSnackBar(json.message)
                    return
                }

                evt.target.blur()
                this.$refs.form.reset()
                vm.comment = ''
                vm.commentErrors = []

            }
        }
    }
</script>

<style scoped>

    .comment-input-container {
    }

    .comment-input-wrapper {
        width: 98%;
        margin: 1px
    }

    .main-wrapper {
        height: 62px
    }

    .comment-content {
        height: 90px
    }

    .comment-user-name {
        width: 100px
    }

    >
    >
    >
    .v-list__tile--avatar {
        height: 90px;
    }

</style>
